import React from 'react'
import { Link } from 'react-router-dom'
const SoftwareDevelopment = () => {
  return (
    <div>
      <section className="solutions-area ptb-80">
        <div className="container">
          <div className="section-title1 section-title1-cus">
            <h1 className='fontkumbh'>
           India's No.1 Mobile App &amp; Website Development company 
            </h1>
            <div className="bar" />
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div style={{ marginTop: 47 }}>
                <p className="text-justify">
                Alobha is global software service, <b>Web Development</b> and <b>Mobile App Development company in Noida</b>, India, focused on helping you make an impact on business and drive value through your IT investment.
                </p>
                <p className="text-justify">
                  Our expertise and commitment in delivering complex IT projects is
                  the reason why we are a trusted service provider across the globe in
                  the software product development and enterprise business segment.
                  It’s a matter of great pride to us that many of these relationships
                  have continued over decades. In India, we are one of the largest
                  software systems integrators with an array of front-end technology
                  deployment services to help client maximize the effectiveness and
                  productivity of their investment in software.
                </p>
                {/* <p class="text-justify">Given the increasingly online and digital world we live in, a comprehensive presence is of utmost importance in order to reach a wider audience; and more importantly, to stay relevant. To help you stay abreast with the changing technologies and to conquer the new age world, Alobha offers web development, software development, mobile application development, CMS development, ERP Software Development, Internet of things (IOT), Machine Learning, IVR, digital marketing and search engine optimization services in Noida, India and all other countries.</p> */}
                {/* <p class="text-justify">Since 2013, Alobha Technologies, website design company, has emerged as a leader in Alobha Solutions and Services. It has been partnering with several Governments bodies, National Libraries, Publishers & Information aggregators across the world by providing cutting edge Content Digitization, Electronic Publishing, Educational Publishing, Digital Libraries and Web Technologies.</p> */}
              </div>
              <div style={{ marginTop: 20 }}>
                <Link to="/about-us" className="btn btn-secondary read-more-css">
                  Read More
                </Link>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="team-image animation-home">
                <img
                  src="assets/img/about-us-section2.webp"
                  alt="Project Screens"
                  width="90%"
                  loading="lazy"
                />
              </div>
              {/* <div class="desige-form">
						<h2>Have a Project?</h2>
						<p>Our leadership will discuss your needs</p>
							<form>
							 <div class="form-group">
						
							    <input type="text" class="form-control" id="" placeholder="Full Name" required>
							  </div>
							  <div class="form-row">
							    <div class="form-group col-md-6">
							
							      <input type="email" class="form-control" id="inputEmail" placeholder="Email" required>
							    </div>
							    <div class="form-group col-md-6">
							     
							      <input type="text" class="form-control" id="" placeholder="Phone" required>
							    </div>
							  </div>
							  <div class="form-group">
							  <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" required></textarea>
							  </div>

							  <div class="" style="text-align: center;    padding: 7px;">
							  	<p>100% Privacy. We Don't Share Your Data.</p>
							  </div>
							  <button type="submit" class="btn btn-secondary" style="width: 100%;">Contact Us Today</button>
							</form>
						</div> */}
            </div>
          </div>
        </div>
      </section>

    </div>
  )
}

export default SoftwareDevelopment